import type { NavigateOptions } from 'react-router';

import type { MethodsOptions } from '@/hooks/useRouter/methodsOptions.ts';

export default function resolveNavigateOptions(
  options: MethodsOptions,
  method: 'push' | 'replace' = 'push'
): NavigateOptions {
  return {
    relative: options.relative ? 'path' : 'route',
    replace: method === 'replace',
    preventScrollReset: !options.scroll,
    viewTransition: options.viewTransition ?? !import.meta.env.STORYBOOK,
  };
}
